import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export const calculateRange = (data = [], rowsPerPage, startIndex, endIndex) => {
    let range = [];
    const num = Math.ceil(data?.length / rowsPerPage);
    for (let i = 1; i <= num; i++) {
        range.push(i);
    }
    let rangeSlice = range.slice(startIndex, endIndex);
    return { range, rangeSlice };
};

export const sliceData = (data = [], page, rowsPerPage, emptyData) => {
    data = data.slice((page - 1) * rowsPerPage, page * rowsPerPage);
    while (data?.length < rowsPerPage) {
        data.push(emptyData);
    }
    return data;
};

export const parisfyData = (data) => JSON.parse(JSON.stringify(data));

export function toFixed(n = 0, fixed = 1) {
    if (typeof n === "number" && n !== Infinity && n !== -Infinity) {
        return Number(`${n || 0}`?.match(new RegExp(`^-?\\d+(?:\.\\d{0,${fixed}})?`))[0]);
    }
    return n;
}
export const exportToExcel = ({ apiData, fileName }) => {
    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
};

export const calcLiveProfit = ({
    type,
    marketPrice,
    candleClosePrice,
    entrySide,
    leverage,
    quantity
}) => {
    let totalProfitPercent;
    let totalProfitDollar;
    let entryPrice = candleClosePrice;
    switch (entrySide) {
        case "BUY":
            totalProfitPercent =
                ((marketPrice - entryPrice) / entryPrice) * 100 * leverage - 0.08 * leverage;
            totalProfitDollar = (totalProfitPercent / 100) * quantity;
            break;
        case "SELL":
            totalProfitPercent =
                -(((marketPrice - entryPrice) / entryPrice) * 100 * leverage) - 0.08 * leverage;
            totalProfitDollar = (totalProfitPercent / 100) * quantity;
        default:
            break;
    }

    if (type === "PERCENTAGE") {
        return totalProfitPercent;
    }
    return totalProfitDollar;
};

export const isEven = (value) => {
    return value % 2 === 0;
};

export const fillRemainingDataGaps = (data, gapSize, emptyObject) => {
    const remainder = Math.ceil(data.length % gapSize);
    const dataCopy = [...data];
    if (remainder != 0) {
        const gapDifference = gapSize - remainder;
        for (let i = 0; i < gapDifference; i++) {
            dataCopy.push(emptyObject);
        }
    }
    return dataCopy;
};
